import { BASE_URL } from "../../constants/defaultValues";
import Dictionary from "../dictionary";
import axios from "axios";

const { dashboard } = Dictionary;

const Dashboard = {
  view: async (paramsObj: any) => {
    return axios.get(BASE_URL + dashboard.dashboard(), { params: paramsObj });
  },
  getReportCharts: async (
    data: {},
    config: { signal: AbortSignal; responseType: any }
  ) => {
    let url = BASE_URL + dashboard.ReportCharts();

    if ("name" in data) {
      url += "?filter=true";
    }

    return axios.post(url, data, {
      signal: config.signal,
      responseType: config.responseType,
    });
  },
};

export default Dashboard;